import requests from "@/request/index";
//获取表格数据
export function getTableData(paramsData,url) {
    return requests({
        url: url,
        data: paramsData,
    });
}
//删除
export function deleteData(data,url) {
    return requests({
        url: url,
        data: data,
    });
}
